// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowDownIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowDownIcon" ref={forwardedRef} {...props}>
      <path d="M10.005 17.25 4 11.234l1.06-1.062 4.184 4.19V2.75h1.497v11.64l4.213-4.214 1.056 1.058z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowDownIcon = /* @__PURE__ */ Object.assign(
  ArrowDownIconComponent,
  { displayName: 'ArrowDownIcon' },
);
